import React from 'react';

import { Dropdown, Tooltip } from 'antd';

import { hasKey } from 'util/utils';

import SortingClose from './SortingClose';
import SortingFilterDropdown from './SortingFilterDropdown';
import SortingRound from './SortingRound';

import { FILTER_COLUMNS } from '../Inventory/Table';

const _ = require('lodash');

const DiamondListingHead = (props) => {
  const item = !props.sort ? [] : props.sort.filter((el) => hasKey(el, props.column.sort));
  const asc = item.length && item[0][props.column.sort] === 'ASC';
  const desc = item.length && item[0][props.column.sort] === 'DESC';
  const mapsort = props.sort ? props.sort.filter((el) => !el.date) : [];

  return (
    <Dropdown
      overlayClassName="tabelDropdownClass"
      overlay={
        mapsort.length || (props.FilterOption !== false && FILTER_COLUMNS.includes(props?.column?.id)) ? (
          props.column &&
          props.column.id && <SortingFilterDropdown {...props} sort={mapsort} column={props.column.id} />
        ) : (
          <></>
        )
      }
      trigger={['click']}
    >
      <div
        className={`tableHeaderMain${props?.column?.id == 'Note' ? 'demo' : ''}`}
        onClick={(e) => e.preventDefault()}
      >
        {props.noDots ? (
          ''
        ) : (
          <span className="listIcon">
            <img src={require('../../assets/svg/InventoryResult/shorting.svg')} alt="icon" />
          </span>
        )}
        {props.column?.desc ? (
          <Tooltip title={props.column?.desc}>
            <span className="taleHeadTitle">{props.header}</span>
          </Tooltip>
        ) : (
          <span className="taleHeadTitle">{props.header}</span>
        )}
        {props.canSort && hasKey(props.canSort, props.column.sort) && (asc || desc) ? (
          <div className="selectShortingMainBlock">
            <div
              className="selectShorting"
              onClick={() => props.column && props.column.sort && props.sortClick(props.column.sort)}
            >
              <span className="selectShortingCount" style={!(asc || desc) ? { margin: 0 } : {}}>
                {props.sort.indexOf(item[0]) + 1}
              </span>
              {asc || desc ? (
                <span className="selectShortingArrow">
                  <img
                    src={
                      asc
                        ? require('../../assets/svg/InventoryResult/shortinglistup.svg')
                        : require('../../assets/svg/InventoryResult/shortinglistdown-white.svg')
                    }
                  />
                </span>
              ) : null}
            </div>
            <SortingClose
              onClick={() => {
                const sort = [];
                const id = props.column.sort;
                _.each(props.sort, (val) => {
                  if (!hasKey(val, id)) sort.push(val);
                });
                props.handleSort(sort);
              }}
            />
          </div>
        ) : null}
        {props.canSort && hasKey(props.canSort, props.column.sort) && !(asc || desc) && (
          <SortingRound
            onClick={() => {
              props.column && props.column.sort && props.sortClick(props.column.sort);
            }}
          />
        )}
      </div>
    </Dropdown>
  );
};

export default React.memo(DiamondListingHead);
